<template>
    <span class="text-warning" v-if="mostrarBtn">
        <i
            class="fa fa-exclamation-circle fa-lg icon-button mr-1"
            title="Justificativas da reprovação"
            @click.stop="mostrarJustificativa()"
        ></i>
    </span>
</template>

<script>
import { comprometimentoStatus } from './ComprometimentoStatus'

export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        mostrarJustificativa() {
            this.$swal({
                title: 'Justificativas da Reprovação',
                html: `${this.comprometimento.justificativas}`,
                icon: 'warning'
            })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.comprometimento.status == comprometimentoStatus.REPROVADO
            )
        }
    }
}
</script>
